// extracted by mini-css-extract-plugin
export default {"TabDrawerLayout":"TabDrawerLayout_TabDrawerLayout__8HTJ4","HeaderContainer":"TabDrawerLayout_HeaderContainer__Kn+zh","ChildrenContainer":"TabDrawerLayout_ChildrenContainer__rwYb3"};